import { render, staticRenderFns } from "./GroupSelector.vue?vue&type=template&id=030ef90d"
import script from "./GroupSelector.vue?vue&type=script&lang=ts"
export * from "./GroupSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports